import api from '../../services/axios';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';

const EditAgent = (props) => {

  const { t } = useTranslation();
  const navigate = useNavigate()
  const { id } = useParams()
  const [formParameters, setFormParameters] = useState({
    sellerName: '',
    agentNameAndSurname: '',
    address: '',
    city: '',
    incomeCode: '',
    agentCredit: 0,
    balance: 0,
    phone: '',
    email: '',
  })
  const [errMsg, setErrMsg] = useState('');

  const update = async (e) => {
    e.preventDefault();

    try {
      await api.put(`/agents_detail/${id}`, {
        agentCredit: parseFloat(formParameters.agentCredit),
        userPhone: formParameters.phone,
        userEmail: formParameters.email,
        address: formParameters.address,
        city: formParameters.city,
      }, {
        headers: {
          'Authorization': `Bearer ${props.loginParameters.accesToken}`
        }
      })
      navigate('/commercial_network/agents')
    } catch (err) {
      if (!err?.response) {
        setErrMsg('No Server Response');
      } else if (err.response?.status === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.response?.status === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Login Failed');
      }
    }
  }

  useEffect(() => {
    const getbankEntryById = async () => {
      const response = await api.get(`/react_agents/${id}`)
      setFormParameters({
        ...formParameters,
        agentNameAndSurname: response.data.registered_business_name,
        incomeCode: response.data.income_code,
        sellerName: response.data.seller[0].user.name,
        address: response.data.active_location_model.address1,
        city: response.data.active_location_model.city,
        agentCredit: parseFloat(response.data.credit).toFixed(2),
        balance: parseFloat(response.data.balance).toFixed(2),
        phone: response.data.user.phone,
        email: response.data.user.email,
      })
    }
    getbankEntryById()
    // hay una advertencia que en el vídeo quitan con la línea de abajo, aunque a mí no me la quita
    //-esLint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const goBack = async (e) => {
    e.preventDefault();
    navigate('/commercial_network/agents')
  }

  return (
    <div style={{padding: "20px"}}>
      <h3 style={{"margin-bottom": "20px"}}>{t('commercial_network.edit_agent')}</h3>
      <form style={{"margin-left": "20px"}}>
        <div className='mb-3'>
          <label className='form-label'>{t('commercial_network.commercial')}</label>
          <input
            value={formParameters.sellerName}
            type='text'
            className='form-control'
            disabled
          />
        </div>
        <div className='mb-3'>
          <label className='form-label'>{t('commercial_network.code')}</label>
          <input
            value={formParameters.incomeCode}
            type='text'
            className='form-control'
            disabled
          />
        </div>
        <div className='mb-3'>
          <label className='form-label'>{t('user.name')}</label>
          <input
            value={formParameters.agentNameAndSurname}
            type='text'
            className='form-control'
            disabled
          />
        </div>
        <div className='mb-3'>
          <label className='form-label'>{t('user.phone')}</label>
          <input
            value={formParameters.phone}
            onChange={(e) => setFormParameters({
              ...formParameters,
              phone: e.target.value
            })}
            type='text'
            className='form-control'
          />
        </div>
        <div className='mb-3'>
          <label className='form-label'>{t('user.email')}</label>
          <input
            value={formParameters.email}
            onChange={(e) => setFormParameters({
              ...formParameters,
              email: e.target.value
            })}
            type='text'
            className='form-control'
          />
        </div>
        <div className='mb-3'>
          <label className='form-label'>{t('location.address')}</label>
          <input
            value={formParameters.address}
            type='text'
            className='form-control'
            onChange={(e) => setFormParameters({
              ...formParameters,
              address: e.target.value
            })}
          />
        </div>
        <div className='mb-3'>
          <label className='form-label'>{t('location.city')}</label>
          <input
            value={formParameters.city}
            type='text'
            className='form-control'
            onChange={(e) => setFormParameters({
              ...formParameters,
              city: e.target.value
            })}
          />
        </div>
        <div className='mb-3'>
          <label className='form-label'>{t('commercial_network.credit')}</label>
          <input
            value={formParameters.agentCredit}
            onChange={(e) => setFormParameters({
              ...formParameters,
              agentCredit: e.target.value
            })}
            type='number'
            className='form-control'
          />
        </div>

        <h4 className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</h4>

        <Button onClick={update} style={{margin: "5px", padding: "5px"}} type='submit' className='btn btn-primary'>{t('update')}</Button>
        <Button onClick={goBack} style={{margin: "5px", padding: "5px"}} type='submit' className='btn btn-primary'>{t('back')}</Button>

      </form>
    </div>
  );
};
export default EditAgent;